// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.prod.ts` with `environmentProd.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  authentication: false,
  apiUrl: '/api/'
};

